import { QrTemplate } from './types';
import { windowSticker } from './windowSticker';
import { businessCard } from './businessCard';
import { flyerA4 } from './flyerA4';

export const qrTemplates: QrTemplate[] = [
  windowSticker,
  businessCard,
  flyerA4,
];

export type { QrTemplate, QrTemplateBusinessInfo, QrTemplateContext, QrMode } from './types';
